import { definirAppDeclaree } from '@taki/app-runtime';
import appInfo from './taki.app.json';
import { JEUX } from './lib/donnees.js';

/**
 * L'APP DEMO TOWN (`demo-town`), UNE APP CANVAS DECLAREE (regle G23).
 *
 * PAS DE PORTE, DONC NI `taki.fields.json` NI `taki.screens.json` : le
 * niveau App Canvas porte l'app entiere dans UNE surface. La
 * derogation est deja accordee et ECRITE dans `taki.app.json` (cle
 * `canvas.app`) ; `definirAppDeclaree` refuse la clef `appCanvas` sans elle,
 * et `pnpm canvas:check` confronte les deux en CI.
 *
 * L'ECRAN VIENT DU SOCLE (`EcranAppCanvas`, `@taki/app-runtime`) : le
 * cadre natif choisi dans la fiche, la recherche et les statistiques, le filet
 * d'erreur, le chargement paresseux. L'app n'ecrit que `Surface.tsx`.
 *
 * LE CHARGEUR RESTE UN `import()` : la surface et son moteur ne partent dans
 * le bundle d'un client que s'il ouvre l'app. Le kit de la surface (galerie,
 * sauvegarde, conflits) : `docs/SURFACES-CANVAS.md`.
 *
 * LE JEU DE DEMONSTRATION (`demo`) : une agence et ses sept clients, ecrits
 * dans les familles de Contact et de Projets (`demo-dataset.ts`). Le socle en
 * pose la ligne « Importer » dans les Parametres de l'app ; le module se charge
 * au clic, jamais au demarrage.
 */
export const demoTownApp = definirAppDeclaree({
  fiche: appInfo,
  appCanvas: { charger: () => import('./Surface.js') },
  demo: {
    ecrit: Object.values(JEUX),
    importer: async ({ sdk, orgId }) => (await import('./demo-dataset.js')).importDemoDataset(sdk, orgId),
  },
});

export default demoTownApp;
